let _ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  try {
    if (!_ctx || _ctx.state === 'closed') {
      _ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
    return _ctx;
  } catch {
    return null;
  }
}

function tone(freq: number, duration: number, vol = 0.12, type: OscillatorType = 'sine') {
  const ctx = getCtx();
  if (!ctx) return;
  try {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = type;
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(vol, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + duration);
  } catch {}
}

// Soft pop when you send a message
export function playMessageSent() {
  tone(700, 0.07, 0.08);
}

// Two-note ping when a message arrives in chat
export function playMessageReceived() {
  tone(620, 0.12, 0.13);
  setTimeout(() => tone(820, 0.1, 0.1), 70);
}

// Lighter two-note tone for platform notifications
export function playNotification() {
  tone(900, 0.1, 0.1);
  setTimeout(() => tone(1100, 0.08, 0.08), 90);
}

// Interactive lessons: bright rising chirp on a correct check
export function playLessonCorrect() {
  tone(660, 0.09, 0.1);
  setTimeout(() => tone(880, 0.1, 0.1), 80);
  setTimeout(() => tone(1175, 0.16, 0.09), 160);
}

// Soft low "bonk" on a wrong check (gentle, never harsh)
export function playLessonWrong() {
  tone(300, 0.14, 0.08, 'triangle');
  setTimeout(() => tone(240, 0.16, 0.07, 'triangle'), 110);
}

// Little fanfare when a lesson is completed
export function playLessonComplete() {
  [523, 659, 784, 1047].forEach((f, i) => setTimeout(() => tone(f, 0.18, 0.1), i * 110));
  setTimeout(() => tone(1319, 0.35, 0.09), 480);
}
